import React from "react";
import {Link} from "react-router-dom";
import {getEditRoute} from "../../../../common/Routing";
import {ROUTES} from "../../../../AppRouter";
import {RowComponentProps} from "../../../../components/widgets/table/RowComponentProps";
import TableDeleteButton from "../../../../components/widgets/table/TableDeleteButton";
import Entitlement from '../../api/entitlement/Entitlement';

const EntitlementRow: React.FC<RowComponentProps<Entitlement>> = ({
  item,
  onDeleteClick,
  entityName
}) => (
  <tr>
    <td>
      <Link
        to={getEditRoute(ROUTES.ENTITLEMENT_EDIT, item.id)}
        className="nav-link"
      >
        {item.name}
      </Link>
    </td>
    <td>{item.type}</td>
    <td>{item.stpType}</td>
    <td>
      <TableDeleteButton
        entityName={entityName}
        onDeleteClick={() => {
          onDeleteClick(item.id);
        }}
      />
    </td>
  </tr>
);

export { EntitlementRow };
